import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';

/*ModalService*/
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { fadeInOutTranslate } from "./elements/animation";
import swal from 'sweetalert2';
/*End ModalService*/

/* NotificationsService */
import { ToastyService, ToastOptions, ToastData } from "ng2-toasty";
/* End NotificationsService */

/* NotifyService */
import { NotificationsService } from "angular2-notifications";
/* End NotifyService */

/* Export Model to CSV */
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
/* End Export Model to CSV */

@Injectable()
export class SharedService {
  language: JSON = environment.language;
  url: string;

  /*ModalService*/
  showDialog: boolean = false;
  @Input() visible: boolean;
  /*End ModalService*/

  /* NotificationsService */
  position: string = 'bottom-right';
  title: string;
  msg: string;
  showClose: boolean = true;
  timeout: number = 5000;
  theme: string = 'bootstrap';
  type: string = 'default';
  closeOther: boolean = false;
  /* End NotificationsService */

  /* NotifyService */
  optionsNotifyService: any = {
    position: ["bottom", "right"],
    timeOut: 2000
  };
  options: any = {
    position: ["bottom", "right"],
  };
  position1: string = 'bottom';
  position2: string = 'right';
  timeOut: number = 2000000;
  showProgressBar: boolean = true;
  pauseOnHover: boolean = true;
  lastOnBottom: boolean = true;
  clickToClose: boolean = true;
  maxLength: number = 0;
  maxStack: number = 8;
  preventDuplicates: boolean = false;
  preventLastDuplicates: boolean = false;
  theClass: string;
  rtl: boolean = true;
  animate: string = 'fromRight';
  icons: string;
  subType: string = 'success';
  /* End NotifyService */

  constructor(private http: Http,
    private toastyService: ToastyService,
    private route: ActivatedRoute,
    private servicePNotify: NotificationsService) {
    this.url = environment.apiAddress;
    this.checkLanguage();
  }
  ngOnInit() {
    this.checkLanguage();    
  }

  userAccess() {
    /* User Access */
    this.get('accessmenu')
      .subscribe(data => {
        let model = data.model;
        for (var i = 0; i < model.length; i++) {

          var element = document.getElementById(model[i].state);
          var display = 'display-none';
          
          if (model[i].key != model[i].controllerKey) {
            if (element != null) {
              element.classList.add("display-none");
            }            
          }
          else {
            display = 'display-block';
          }

          if (element != null) {
            var parentElement = element.parentElement;
            if (parentElement != null) {
              var parentParentElement = parentElement.parentElement;
              if (parentParentElement != null) {
                parentParentElement.classList.add(display);
              }
            }
          }
        }
      });
    /* End User Access */
  }/* User Access */

  post(query, model) {
    let headers = this.getHeaders();
    return this.http.post(
      this.url + query, model, { headers })
      .map((response: Response) => {
        let res = response.json();
        return res;
      });
  }
  get(query) {
    let headers = this.getHeaders();
    return this.http.get(this.url +
      query, { headers })
      .map((res: Response) => res.json());
  }
  getHeaders() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let authToken = localStorage.getItem('auth_token');
    headers.append('Authorization', `Bearer ${authToken}`);
    return headers;
  }

  /* Export Model to CSV */
  exportCsv(model, header, nameFile = 'My Report') {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      headers: header
    };
    new Angular2Csv(model, nameFile, options);
  }
  /* End Export Model to CSV */

  /*ModalService*/
  openMyModal(event) {
    document.querySelector("#" + event).classList.add('md-show');
  }
  closeMyModal(event) {
    ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
  }
  openSuccessCancelSwal(title, text, confirmButtonText, cancelButtonText, cancelled, CancelledText) {
    swal({
      title: title,
      text: text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      confirmButtonClass: 'btn btn-success m-r-10',
      cancelButtonClass: 'btn btn-danger',
      buttonsStyling: false
    }).then(function () {
      return true;
      //swal(
      //  'Deleted!',
      //  'Your file has been deleted.',
      //  'success'
      //)
    }, function (dismiss) {
      if (dismiss === 'cancel') {
        swal(
          cancelled,
          CancelledText,
          'error'
        )
        return false;
      }
    }).catch(swal.noop);

    return false;
  }
  openSuccessSwal(title, text) {
    swal({
      title: title,
      text: text,
      type: 'success'
    }).catch(swal.noop);
  }
  /*End ModalService*/

  /* NotificationsService */
  addToast(options) {
    if (options.closeOther) {
      this.toastyService.clearAll();
    }
    this.position = options.position ? options.position : this.position;
    let toastOptions: ToastOptions = {
      title: options.title,
      msg: options.msg,
      showClose: options.showClose,
      timeout: options.timeout,
      theme: options.theme,
      onAdd: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added removed!');
      }
    };

    switch (options.type) {
      case 'default': this.toastyService.default(toastOptions); break;
      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }
  /* End NotificationsService */

  /* NotifyService */
  addNotify(options) {
    //this.pauseOnHover = (options.indexOf("pauseOnHover") > -1) ? options.pauseOnHover : this.pauseOnHover;
    //this.servicePNotify.remove();
    this.options = {
      position: [("position1" in options) ? options.position1 : this.position1, ("position2" in options) ? options.position2 : this.position2],
      maxStack: ("maxStack" in options) ? options.maxStack : this.maxStack,
      timeOut: options.timeOut ? options.timeOut : this.timeOut,
      showProgressBar: ('showProgressBar' in options) ? options.showProgressBar : this.showProgressBar,
      pauseOnHover: ('pauseOnHover' in options) ? options.pauseOnHover : this.pauseOnHover,
      lastOnBottom: ('lastOnBottom' in options) ? options.lastOnBottom : this.lastOnBottom,
      clickToClose: ('clickToClose' in options) ? options.clickToClose : this.clickToClose,
      maxLength: options.maxLength ? options.maxLength : this.maxLength,
      preventDuplicates: ('preventDuplicates' in options) ? options.preventDuplicates : this.preventDuplicates,
      preventLastDuplicates: ('preventLastDuplicates' in options) ? options.preventLastDuplicates : this.preventLastDuplicates,
      theClass: options.theClass ? options.theClass : this.theClass,
      rtl: ('rtl' in options) ? options.rtl : this.rtl,
      animate: options.animate ? options.animate : this.animate,
      icons: options.icons ? options.icons : this.icons
    }
    switch (options.type) {
      case 'success':
        this.servicePNotify.success(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      case 'error':
        this.servicePNotify.error(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      case 'alert':
        this.servicePNotify.error(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      case 'warn':
        this.servicePNotify.error(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      case 'info':
        this.servicePNotify.info(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      case 'create':
        this.servicePNotify.create(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg,
          options.type ? options.type : this.subType
        );
        break;
      case 'html':
        this.servicePNotify.html(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
      default:
        this.servicePNotify.alert(
          options.title ? options.title : this.title,
          options.msg ? options.msg : this.msg
        );
        break;
    }
  }
  /* End NotifyService */

  removeClass(elem, className) {
    var element = document.getElementById(elem);
    element.classList.remove(className);
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  clearFileInput(ctrl) {
    try {
      ctrl.value = null;
    } catch (ex) { }
    if (ctrl.value) {
      ctrl.parentNode.replaceChild(ctrl.cloneNode(true), ctrl);
    }
  }

  checkLanguage() {
    let lang: any = {
      fromDore: "از دوره",
      toDore:"تا دوره",
      briefInformation:"اطلاعات اجمالی",
      ersalMojadadForoshTelegram: "ارسال مجدد فروش به تلگرام",
      ersalMojadadDoreTelegram:"ارسال مجدد نتایج پایان دوره به تلگرام",
      captcha:"کد تصویری",
      reStart:"شروع مجدد",
      goToBank:"ورود به بانک",
      nextStep:"مرحله بعد",
      kilIIS:"شروع مجدد IIS",
      showInMenu:"نمایش در منو",
      start:"شروع",
      nameSahebeCard:"نام صاحب کارت",
      loginUrl:"آدرس ورود",
      hekmatIranian: "حکمت ایرانیان",
      listAccountCardToCard:"لیست حساب های کارت به کارت",
      accountCardToCard:"حساب کارت به کارت",
      manageAppCardToCard:"مدیریت برنامه کارت به کارت",
      insertUserBankCard:"ثبت شماره کارت",
      cardNumber:"شماره کارت",
      userBankCards:"کارت های بانکی کاربر",
      properties:"مشخصات",
      guarantee:"ضمانت",
      summary:"خلاصه",
      bestSeller:"بهترین فروشنده",
      special:"مخصوص",
      price : "قیمت",
      oldPrice :"قیمت قدیمی",
      group:"گروه",
      mainGroup:"گروه اصلی",
      subGroup:"گروه فرعی",
      products:"محصولات",
      totalActiveGames: "تعداد مسابقات فعال",
      countUserMehvar: "تعداد کاربر شبکه ای",
      countNamayandehMehvar: "تعداد کاربر نماینده محور",
      requestWithdrawal: "تعداد درخواست برداشت وجه تایید نشده",
      registerUsers: "آمار ثبت نام کاربران",
      finishGamesSales: "فروش دوره های پایان یافته",
      onlineGameResult: "نتایج دوره های در حال اجرا",
      activeGamesSales: "فروش دوره های فعال",
      controllerKey: "کنترلر",
      shomareMojavez: "شماره مجوز",
      successUploadFishVarizi: "آپلود فیش واریزی با موفقیت انجام شد",
      telegramNamayandehMehvar: "کانال تلگرام نماینده ها",
      smsNumber: "شماره پیامک",
      listSmsServers: "لیست سرویس های پیامک",
      noticeUser: "اطلاعیه کاربر",
      noticeNamayandeh: "اطلاعیه نماینده",
      fishVarizi: "فیش واریزی",
      flag: "پرچم",
      guestFlag: "پرچم مهمان",
      hostFlag: "پرچم میزبان",
      analysisLink: "لینک آنالیز",
      xmlExport: "خروجی XML",
      buildBanner: "ذخیره و ساخت بنر",
      registerKarbarMehvar: "ثبت نام کاربر محور",
      registerNamayandehMehvar: "ثبت نام نماینده محور",
      port: "پورت",
      idCannelUser: "آیدی کانال یا کاربر",
      receiverEmailAddress: "آدرس میل دریافت کننده",
      typeSite: "نوع سایت",
      justChangeCodeKol: "فقط تغییر کد کل",
      newCodeJozKol: "کد کل و کد جز جدید",
      defaultCodeJozKol: "کد کل و کد جز پیش فرض",
      siteSubset: "سایت زیر مجموعه",
      motherSite: "سایت مادر",
      motherServer: "سرور مادر",
      paymentForwardAddress: "آدرس فوروارد درگاه پرداخت",
      allowVoucherUser: "کاربر اجازه استفاده از کد شارژ را دارد",
      allowVoucherNamayandehJoz: "نماینده جز اجازه استفاده از کد شارژ را دارد",
      allowVoucherNamayandehKol: "نماینده کل اجازه استفاده از کد شارژ را دارد",
      reConfirmGhavanin: "قوانین تغییر کرده است. مجدد کاربران تایید نمایند.",
      noticesSiteAddress: "آدرس سایت اطلاع رسانی",
      socialNetwork: "شبکه های اجتماعی",
      instagram: "اینستاگرام",
      instagramAddress: "آدرس اینستاگرام",
      register: "ثبت نام",
      payCardsToCard: "شارژ کارت به کارت",
      downloadExportExcel: "دانلود خروجی اکسل",
      zarinpal: "زرین پال",
      webgateId: "شناسه درگاه پذیرنده",
      startPayanDore: "شروع پایان دوره",
      operationCancelled: "عملیات لغو شد",
      operationLongTime: "عملیات زمان بر است. لطفا شکیبا باشید.",
      notice: "توجه",
      acceptedFinishGame: "امتیاز نفرات اول: [emtiaz1] <br/> تعداد: [tedadNafar1] <br/> تعداد سهم: [tedadSahm1] <br/> مبلغ هر سهم: [arzeshSahm1] <br/> امتیاز نفرات دوم: [emtiaz2] <br/>تعداد: [tedadNafar2] <br/> تعداد سهم: [tedadSahm2] <br/> مبلغ هر سهم: [arzeshSahm2] <br/> آیا از نتیجه اطمینان دارید؟",
      successValue: "ارزش موفقیت",
      serverUrl: "آدرس سرور",
      rsaKeyValue: "کلید خصوصی ﻓﺮوﺷﻨﺪﻩ",
      chargeCancelled: "شارژ حساب لغو شد",
      widthrawCancelled: "برداشت وجه لغو شد",
      acceptedIncorrectMablagh: "مبلغ به نظر اشتباه می باشد؛ تایید می کنید؟",
      acceptedMablaghMoreThen: "مبلغ شما بیشتر از 100,000 تومان است؛ تایید می کنید؟",
      warning: "اخطار",
      sms: "پیامک",
      sendPasswordSuccessfull: "کلمه عبور با موفقیت تغییر یافت و برای کاربر ارسال شد.",
      sendPassUser: "ارسال رمز برای کاربر",
      downlaodSuccessfull: "دانلود با موفقیت انجام شد.",
      testSuccessfull: "تست با موفقیت انجام شد.",
      summery1Win: "تعداد کل فرم های اول",
      summery2Win: "تعداد کل فرم های دوم",
      totalSummery: "مبلغ کل جمع شده",
      countCardForosheSite: "تعداد فرم سایت",
      countCardForosheSonati: "تعداد فرم سنتی",
      foroshSite: "فروش سایت",
      foroshSonati: "فروش سنتی",
      sum: "مجموع",
      uploadPicture: "آپلود تصویر فرم",
      picture:"تصویر",
      free: "آزاد",
      used: "استفاده شده",
      banned: "مسدود شده",
      mablaghKochaktarAz: "مبلغ کوچکتر از",
      mablaghBozorgtarMosavi: "مبلغ بزرگتر مساوی",
      darsad: "درصد",
      aboutUs: "درباره ما",
      accepted: "پذیرفتن درخواست",
      acceptedDarkhastVajh: "آیا درخواست برداشت وجه را می پذیرید؟",
      acceptedDarkhastVajhMessage: "درخواست برداشت وجه شما تایید و به شماره کارت داده شده واریز شده است.",//"درخواست برداشت وجه شما تایید و به بانک ارسال شده است. طی 1 الی 3 روز کاری آینده به حساب شما واریز خواهد شد."
      acceptedDarkhastVajhMessageCard: "درخواست برداشت وجه شما تایید و به شماره کارت [value] واریز شده است.",//"درخواست برداشت وجه شما تایید و به بانک ارسال شده است. طی 1 الی 3 روز کاری آینده به حساب شما واریز خواهد شد."
      acceptedDarkhast: "آیا درخواست را می پذیرید؟",
      acceptedDeleteForm: "آیا از حذف اطمینان دارید؟",
      acceptedRestoreBackup: "آیا از بازیابی نسخه پشتیبان اطمینان دارید؟",
      action: "فعالیت ها",
      active: "فعال",
      activeGame: "مسابقات فعال",
      activeGames: "مسابقات فعال",
      addConditionCopy: "افزودن شرط کپی جدید",
      address: "آدرس",
      adminDefaultLanguage: "زبان پیشفرض بخش مدیریت",
      adminPanel: "پنل مدیریت",
      adminURL: "آدرس پنل مدیریت",
      allField: "تمام فیلدها",
      allGames: "تمام مسابقات",
      listGames: "لیست مسابقه ها",
      allRequeste: "تمام درخواست ها",
      amozeshDaramd: "آموزش درآمد میلیونی",
      archive: "آرشیو",
      arzeshSahm1: "مبلغ هدیه هر سهم اول",
      arzeshSahm2: "مبلغ هدیه هر سهم دوم",
      automaticFullBanAttempts: "تعداد تلاش برای مسدود نمودن همیشگی",
      automaticJob: "عملیات خودکار زمان بندی شده",
      newAutomaticJob: "افزودن عملیات خودکار",
      backTo: "بازگشت به",
      backup: "فایل پشتیبان",
      listBackup: "لیست فایل های پشتیبان",
      backupLocation: "مسیر فایل های پشتیبان",
      bank: "بانک",
      bankCardNumber: "شماره شبا حساب",
      bankName: "نام بانک",
      blockedWords: "نام کاربری غیرمجاز",
      blockUserAfterAttempt: "تعداد تلاش قبل از مسدود نمودن کاربر",
      bug: "خطا",
      cancel: "انصراف",
      canceled: "لغو",
      canceledGames: "مسابقات لغو شده",
      changeMojodi: "افزایش / کاهش موجودی",
      changePassword: "تغییر کلمه عبور",
      chargeSuccessfull: "شارژ با موفقیت انجام شد.",
      close: "بستن",
      code: "کد",
      codeCharge: "کد شارژ",
      chargeNamayandehKol: "شارژ حساب نماینده کل",
      codeJoz: "کد جز",
      listCodeJoz: "لیست کد جز",
      newCodeJoz: "افزودن کد جز",
      codeKol: "کد کل",
      newCodeKol: "افزودن کد کل",
      codeMeli: "کد ملی",
      codeNamayandeh: "کد نماینده",
      conditionCopy: "شرایط کپی فرم ها",
      confirmPassword: "تکرار کلمه عبور",
      contact: "تماس با ما",
      contain: "شامل",
      content: "متن پیام",
      copy: "کپی",
      costCard: "مبلغ فرم",
      count: "تعداد",
      countCopy: "تعداد کپی",
      countSubUsers: "تعداد کاربر زیر مجموعه",
      customBody: "تگ محتوا سایت",
      customHead: "تگ هد",
      jayeze:"جایزه",
      darsadNamKol: "درصد نماینده",
      sahmForoshDoreh: "سهم فروش دوره",
      mandeh: "مانده",
      daramadAzJayeze: "درآمد سایت از جایزه کاربران زیر مجموعه",
      daramadDore: "گزارش مالی دوره",
      darkhastVajhCancelledText: "وضعیت درخواست برداشت وجه تغییری نکرد :)",
      darsadeFormRefrence: "درصد پورسانت ثبت فرم کاربر شیکه ای",
      darsadeJayezeNamayandeh: "درصد پورسانت مستقیم",
      darsadeJayezeRefrence: "درصد پورسانت جایزه کاربر شبکه ای",
      darsadeNamayandehMehvarSite: "درصد دریافت سایت از نماینده محور",
      darsadeShabakeiSite: "درصد دریافت سایت از کاربرمحور",
      defaultResellerPercent: "درصد پیش فرض سرشاخه",
      darsadNamayandegi: "درصد نمایندگی",
      darsadSarshakhe: "درصد سرشاخه",
      dashboard: "میز کار",
      dataBaseCancelledText: "در پایگاه داده هیچ تغییری ایجاد نشد :)",
      date: "تاریخ",
      deleteCancelledText: "هیچ اطلاعاتی حذف نشد :)",
      digitalVersion: "ورژن",
      androidVersion: "ورژن اندروید",
      iosVersion: "ورژن IOS",
      windowsVersion: "ورژن ویندور",
      disable: "غیرفعال",
      dore: "دوره",
      draft: "پیام پیش نویس",
      edit: "ویرایش",
      email: "ایمیل",
      emailPassword: "کلمه عبور",
      emailServerAddress: "آدرس سرور میل",
      emailSmtpPort: "شماره پورت SMTP",
      emailUsername: "نام کاربری",
      emtiazNafar1: "امتیاز  نفر اول",
      emtiazNafar2: "امتیاز  نفر دوم",
      enableCaptchaAfterAttempt: "تعداد دفعات تلاش ناموفق برای فعال سازی کپچا",
      endDate: "تاریخ پایان",
      equal: "برابر",
      equalAndGreaterMablagh: "مبلغ فرم بزرگتر مساوی",
      equalAndLessMablagh: "مبلغ فرم کوچکتر مساوی",
      matnPaziroftanCharge: "متن درخواست وجه",
      downloadFormPrint: "دانلود فرم پرینت",
      error: {
        catchError: "[value]",
        cardNumberFormatIncorrect: "فرمت شماره کارت صحیح نمی باشد!",
        cardNumberRequired: "شماره کارت وارد نشده است!",
        cardNumberLengthIncorrect: "طول شماره کارت باید 16 حرف باشد!",
        duplicatedCardNumber: "شماره کارت تکراری می باشد!",
        getPostRequired: "یکی از انواع اکشن را انتخاب نمایید!",
        emptyFile: "فایل خالی است!",
        imageExtension: "پسوند مجاز برای آپلود تصویر [value] است!",
        codeIncorrect: "لطفا نوع کد کل و جز را انتخاب نمایید!",
        defineCodeKol: "لطفا کد کل را تعریف نمایید!",
        defineCodeJoz: "لطفا کد جز را تعریف نمایید!",
        codeJozRequired: "کد جز وارد نشده است!",
        codeKolRequired: "کد کل وارد نشده است!",
        nameRequired: "نام وارد نشده است!",
        serverUrlRequired: "آدرس سرور وارد نشده است!",
        resultGameInvalid: "نتیجه بازی در سطر [index] با نتایج آنلاین یکسان نمی باشد!",
        moreThanOneResult: "لطفا در هر ردیف فقط یک جواب انتخاب نمایید!",
        moreThanTwoWinner: "بیش از دو برنده داریم!",
        bankTypeRequired: "نوع بانک انتخاب نشده است!",
        smsTypeRequired: "نوع سرویس پیامک انتخاب نشده است!",
        cardNotExist: "هیچ فرمی برای این مسابقه یافت نشد!",
        existCode: "کد مورد نظر شما قبلا برای نماینده ای ثبت شده است!",
        accountancyExistBank: "اسناد حسابداری برای بانک وجود دارد!",
        autoStartDateInvalid: "تاریخ شروع عملیات از پایان مسابقه کوچکتر می باشد",
        cardValueInvalid: "حداقل ارزش فرم نمی تواند از حداکثر ارزش بیشتر یا مساوی باشد!",
        codeInvalid: "کد وارد شده صحیح نمی باشد!",
        duplicatedCode: "کد تکراری می باشد!",
        duplicatedRecord: "رکورد تکراری می باشد!",
        codeJozIncorrect: "کد جز نماینده وارد شده صحیح نمی باشد!",
        codeNotIntered: "کد نمایندگی وارد نشده است!",
        conditionCopyRequired: "لطفا شرایط کپی فرم ها را مشخص نمایید!",
        confirmPasswordRequired: "تکرار کلمه عبور وارد نشده است!",
        contentRecordRequired: "محتوا وارد نشده است!",
        contentRequired: "متن پیام وارد نشده است!",
        countFormatIncorrect: "فرمت تعداد صحیح نمی باشد!",
        darsadIncorrect: "فرمت درصد اشتباه می باشد!",
        darsadIsOver: "درصد نمایندگی بیش از حد تعیین شده می باشد!",
        darsadNamayandegiIncorrect: "درصد نمایندگی از درصد نماینده های زیرمجموعه کمتر است.",
        dateIncorrect: "تاریخ نامعتبر است!",
        doreRequired: "شماره دوره وارد نشده است!",
        telegramAdminRequired: "شناسه تلگرام وارد نشده است!",
        duplicatedTelegramId: "شناسه تلگرام تکراری می باشد!",
        dublicateNamayandeh: "نماینده تکراری می باشد!",
        duplicatedDore: "شماره دوره تکراری می باشد!",
        duplicatedSaleReferenceId: "شماره تراکنش تکراری می باشد!",
        duplicatedResellerCode: "کد نمایندگی تکراری می باشد!",
        emailIncorrect: "فرمت ایمیل صحیح نمی باشد!",
        emailIsUsed: "آدرس ایمیل تکراری می باشد!",
        emailNotExist: "ایمیل وارد شده در سیستم موجود نمی باشد!",
        existTaskDore: "تسک دوره وجود دارد!",
        formGameIncorrect: "برای تمام بازی های مسابقه لیگ و تاریخ مشخص نمایید!",
        gameHelpRequired: "راهنما مسابقه انتخاب نشده است!",
        gameIncorrect: "مسابقه نامعتبر است!",
        gameNameRequired: "نام مسابقه انتخاب نشده است!",
        gameStateIncorrect: "وضعیت مسابقه نامعتبر است!",
        gameStateInvalid: "وضعیت مسابقه در سطر [index] نامعتبر است!",
        gameStateRequired: "وضعیت مسابقه انتخاب نشده است!",
        gameTypeRequired: "نوع مسابقه انتخاب نشده است!",
        guestGoalsIncorrect: "تعداد گل مهمان نامعتبر است!",
        guestGoalsInvalid: "تعداد گل مهمان در سطر [index] نامعتبر است!",
        hostGoalsIncorrect: "تعداد گل میزبان نامعتبر است!",
        hostGoalsInvalid: "تعداد گل میزبان در سطر [index] نامعتبر است!",
        invalidConditionCopy: "شرایط کپی فرم ها نامعتبر است!",
        invalidDarkhastVajh: "درخواست برداشت وجه نامعتبر است!",
        invalidGameState: "در سطر [index] بازی در وضعیت [gameState] قرار دارد؛ اما [prop] نامعتبر است!",
        invalidSerialLimit: "بازه سریالی اشتباه می باشد!",
        invalidUsernameOrPassword: "نام کاربری و یا کلمه عبور اشتباه می باشد!",
        jobStartTimeNotIntered: "تاریخ شروع تسک وارد نشده است!",
        leagueInvalid: "لیگ در سطر [index] نامعتبر است!",
        ligTimeInvalid: "تاریخ لیگ در سطر [index] نامعتبر است!",
        mablaghFormatIncorrect: "فرمت مبلغ صحیح نمی باشد!",
        maximumMablaghRequired: "حداکثر مبلغ وارد نشده است!",
        merchantCodeRequired: "شماره شناسائی فروشنده وارد نشده است!",
        messageTypeRequired: "نوع پیام انتخاب نشده است!",
        minWaiteRequired: "لطفا حداقل [value] منتظر بمانید!",
        mobieIsUsed: "شماره موبایل تکراری می باشد!",
        mobileIncorrect: "فرمت موبایل صحیح نمی باشد!",
        mobileNotExist: "شماره موبایل وارد شده در سیستم موجود نمی باشد!",
        mobileOrEmailRequired: "حداقل یکی از دو فیلد موبایل یا ایمیل را وارد نمایید!",
        mojodiKafiNist: "موجودی کافی نمی باشد!",
        namayandehNotSelected: "نماینده انتخاب نشده است!",
        noteRequired: "توضیح وارد نشده است!",
        passwordLength: "حداقل طول کلمه عبور 6 حرف می باشد!",
        passwordNotMatched: "کلمه عبور و تکرار آن با هم مطابقت ندارند!",
        passwordRequired: "کلمه عبور وارد نشده است!",
        serialFromRequired: "شروع بازه سریالی اشتباه می باشد!",
        serialToRequired: "پایان بازه سریالی اشتباه می باشد!",
        shebaLengthIncorrect: "طول شماره شبا باید 26 حرف باشد!",
        shebaSaderatInvalid: "لطفا شماره شبا به جز بانک صادرات را وارد نمایید!",
        terminalCodRequired: "شماره شناسائی ترمینال وارد نشده است!",
        titleRecordRequired: "عنوان وارد نشده است!",
        titleRequired: "عنوان پیام وارد نشده است!",
        UnexpectedError: "خطای غیر منتظره رخ داده است!",
        userIncorrect: "کاربر نامعتبر می باشد!",
        userIsDisabled: "کاربر شما غیر فعال می باشد!",
        userNameRequired: "نام کاربری وارد نشده است!",
        userPermision: "کاربر شما حق دسترسی به این محدوده را ندارد!",
        userRequired: "هیچ کاربری انتخاب نشده است!",
        userUnderAnotherReseller: "کاربر انتخاب شده زیر مجموعه نماینده دیگری می باشد!",
        zaribIncorrect: "ضریب نامعتبر است!",
        invalidDarkhast: "درخواست شما نامعتبر است!",
        errorRefrenceOrNamKol: "نام کاربری معرف و یا نماینده کل یافت نشد",
        refMustBeNamKol: "نام کاربری معرف باید نماینده کل باشد",       
        refMustBeNamJoz: "نام کاربری معرف باید نماینده جز باشد"
      },
      exit: "خروج",
      family: "نام خانوادگی",
      nameFamily: "نام و نام خانوادگی",
      telegramUserName: "نام کاربری تلگرام",
      telegramId: "شناسه تلگرام",
      activeTelegram: "تلگرام فعال",
      finishGames: "مسابقات تمام شده",
      fireBaseApikey: "کلید فایربیس",
      fireBasePackageName: "نام پکیج فایربیس",
      firebaseSenderId: "شناسه فرستنده فایربیس",
      forgetPassword: "بازیابی کلمه عبور",
      forgotMessage: "نگران نباشید.",
      forgotWelcome: "کلمه عبور خود را فراموش کرده اید؟",
      form: "فرم",
      formList: "لیست فرم ها",
      foroshDore: "فروش دوره",
      forosheKarbar: "فروش کاربر",
      forosheKarbarMehvar: "فروش کاربر محور",
      forosheKol: "فروش کل",
      forosheNamayandegan: "فروش نماینده محور",
      foroshKol: "فروش کل",
      foroshNamayandeh: "فروش نماینده",
      foroshNamayandehKol: "فروش نماینده کل",
      karbarCount: "تعداد کاربر شرکت کننده",
      namayandehCount: "تعداد نماینده شرکت کننده",
      karbarMovaghat: "تعداد فرم های موقت",
      fromDate: "از تاریخ",
      ftpAddress: "آدرس FTP",
      ftpPassword: "پسورد FTP",
      ftpUsername: "نام کاربری FTP",
      game: "مسابقه",
      gameHelp: "راهنما مسابقه",
      newGameHelp: "افزودن را هنما",
      gameName: "نام مسابقه",
      newGameName: "افزودن نام بازی",
      gamesState: {
        notStarted: "شروع نشده",
        firstHalf: "نیمه اول",
        secondHalf: "نیمه دوم",
        breakGame: "استراحت بین دو نیمه",
        finish: "پایان",
        canceled: "لغو شده",
        winGuest: "برد مهمان",
        winHost: "برد میزبان",
        tasavi: "تساوی"
      },
      gameState: "وضعیت مسابقه",
      gameType: "نوع مسابقه",
      newGameType: "نوع مسابقه جدید",
      ghavanin: "قوانین",
      goal: "گل",
      googleAnalycticCode: "google Analyctic کد",
      guest: "مهمان",
      guestGoals: "تعداد گل مهمان",
      host: "میزبان",
      hostGoals: "تعداد گل میزبان",
      inProgressGames: "مسابقات در حال انجام",
      isAccepted: "پذیرفته شده",
      isIranTime: "تاریخ ایران؟",
      isRejected: "رد شده",
      isRequested: "در انتظار بررسی",
      isSingleSite: "سایت مستقل",
      jayezeNafar1: "جایزه نفر اول",
      jayezeNafar2: "جایزه نفر دوم",
      jobState: {
        waiting: "انتظار",
        running: "اجرا",
        done: "تکمیل",
        canceled: "لغو",
        failure: "شکست"
      },
      labels: "برچسب",
      lastSerial: "آخرین سریال",
      leage: "لیگ",
      newLeague: "افزودن لیگ",
      listBanks: "لیست درگاه های پرداخت",
      listNamayandehJoz: "لیست نماینده جز",
      listNamayandehKol: "لیست نماینده کل",
      listUsers: "لیست کاربران",
      loginWelcome: "با تشکر تیم نرم افزاری",
      mablagh: "مبلغ",
      mablaghKolGame: "جمع کل هدایا",
      makeAsRead: "تنظیم به عنوان خوانده شده",
      mande: "مانده",
      maxCardValue: "حداکثر ارزش فرم",
      maximumKhordCost: "حداکثر مبلغ خورد رادیکالی",
      maximumMablagh: "حداکثر مبلغ",
      mellat: "ملت",
      merchantCode: "شماره شناسائی فروشنده",
      message: "پیام",
      messageForgotPassword: "لینک بازیابی کلمه عبور به ایمیل و تلفن همراه شما ارسال شده است.",
      messages: "پیام ها",
      minCardValue: "حداقل ارزش فرم",
      minimumDarkhastVajh: "حداقل مبلغ درخواست وجه",
      minimumMablaghCharge: "حداقل مبلغ شارژ",
      minute: "دقیقه",
      moassese: "موسسه",
      mobile: "شماره موبایل",
      mojodi: "موجودی",
      mojodiNamayandehMehvar: "موجودی نماینده محور",
      mojodiSandogh: "موجودی صندوق",
      mojodiUserMehvar: "موجودی کاربر محور",
      motherForm: "فرم مادر",
      moveDown: "انتقال به سطر پایین",
      moveTop: "انتقال به سطر بالا",
      multiAccountUsers: "کاربران چند اکانته",
      namayandeh: "نماینده",
      namayandehJoz: "نماینده جز",
      namayandehKol: "نماینده کل",
      namayandehMehvar: "نماینده محور",
      name: "نام",
      nameUser: "نام کاربر",
      newDraft: "پیام پیش نویس جدید",
      newGame: "مسابقه جدید",
      newMessage: "ارسال پیام",
      newMessageForm: "پیام جدید از",
      newStartupMessage: "پیام آغازین جدید",
      no: "خیر",
      option: "گزینه",
      orderOption: "شماره گزینه",
      orderQuestion: "شماره سوال",
      ostan: "استان",
      pardakhtBeKarbaran: "پرداخت پورسانت طبقاتی",
      pardakhtBeNamayandegan: "پرداخت به نمایندگان",
      pardakhtBeSiteCopyJayezeh: "جایزه کپی به سایت",
      pardakhtBeSiteKarbarMehvar: "در آمد سایت از کاربر محور",
      pardakhtBeSiteNamayandegan: "در آمد سایت از نماینده محور",
      pardakhtJayeze: "پرداخت جایزه",
      pardakhtKol: "جمع کل پرداخت موسسه",
      pardakhtKolSite: "در آمد کل سایت",
      pardakhtSarshakhe: "پرداخت به سرشاخه ها",
      pardakhtTakhfif: "پرداخت تخفیف کاربر محور",
      parsian: "سامان",
      pasargad: "پاسارگاد",
      password: "کلمه عبور",
      passwordChangeSuccessfully: "کلمه عبور با موفقیت تغییر یافت.",
      fotokolBarandegan: "فتوکل",
      payanDoreh: "پایان دوره",
      persian: "فارسی",
      profile: "پروفایل",
      puseGames: "مسابقات متوقف شده",
      question: "سوال",
      questions: "سوالات",
      newQuestionsGame: "مسابقه فرهنگی جدید",
      questionsGame: "مسابقات فرهنگی",
      listQuestionsGame: "لیست مسابقات فرهنگی",
      read: "خوانده شده",
      readMessage: "مشاهده پیام",
      receivedMessages: "پیام های دریافتی",
      receivedMessagesForm: "پیام های دریافتی از",
      record: "رکورد",
      refrence: "معرف",
      rejectedDarkhastVajh: "آیا درخواست برداشت وجه را رد می نمایید؟",
      rejectedDarkhastVajhMessage: "درخواست برداشت وجه شما تایید نشده است.",
      rejectedDarkhast: "آیا درخواست را رد می نمایید؟",
      rememberMe: "مرا به خاطر بسپار",
      report: "گزارش",
      reportAccountancy: "گزارشات حسابداری",
      requestMoney: "درخواست برداشت وجه",
      resetSendPassword: "تنظیم مجدد و ارسال کلمه عبور جدید برای من",
      restoreBackup: "بازیابی نسخه پشتیبان",
      rowCount: "تعداد سطر",
      runningGame: "نتایج آنلاین مسابقات",
      sahebNamayandehMehvar: "صاحب نماینده محور",
      sahebShabakehi: "صاحب شبکه ای",
      saleReferenceId: " شماره تراکنش",
      sandogh: "صندوق",
      sarshakhe: "سرشاخه",
      save: "ذخیره",
      saveMovaghatGames: "مسابقات ذخیره موقت شده",
      saveNotification: "اطلاعات با موفقیت ذخیره شدند.",
      search: "جستجو",
      select: "انتخاب",
      selectAll: "انتخاب همه",
      deselectAll: "عدم انتخاب همه",
      selected: "منتخب",
      selectedMessage: "پیام انتخاب شد.",
      selectNextUser: "انتخاب کاربر بعدی",
      selectUsers: "انتخاب کاربرها",
      send: "ارسال",
      sendTo: "ارسال به",
      sendToAll: "ارسال به همه",
      sentMessages: "پیام های ارسالی",
      sentMessagesTo: "پیام های ارسالی به",
      sentMessageSuccessfull: "ارسال [value] پیام با موفقیت ارسال شد.",
      sentMessageSuccessfully: "پیام با موفقیت ارسال شد.",
      serial: "سریال",
      serialFrom: "شروع بازه سریالی",
      serialTo: "پایان بازه سریالی",
      setting: "تنظیمات",
      newXmlSetting: "افزودن تنظیمات خروجی XML",
      listXmlSetting: "لیست تنظیمات خروجی XML",
      settingReceiveNotifcation: "تنظیمات دریافت پیامک",
      shahrestan: "شهرستان",
      shomareSanad: "شماره سند",
      show: "نمایش",
      showAll: "نمایش همه",
      signIn: "ورود",
      siteClosed: "وب سایت بسته شده است",
      siteCloseReason: "دلیل بسته شدن وب سایت",
      sodMoaseseCopyJayezeh: "جایزه کپی به موسسه",
      sodMoaseseDore: "سود موسسه",
      sportGames: "مسابقات ورزشی",
      startDate: "تاریخ شروع",
      startupMessage: "پیام آغازین",
      subUsers: "کاربران زیر مجموعه",
      success: "موفق",
      successAccepted: "قبول درخواست برداشت وجه با موفقیت انجام شد :)",
      successDelete: "حذف با موفقیت انجام شد.",
      successRejected: "رد درخواست برداشت وجه با موفقیت انجام شد.",
      successRestore: "بازیابی نسخه پشتیبان با موفقیت انجام شد.",
      sumCostCards: "مجموع فرم ها",
      suspend: "معلق",
      taghirMakanHostGuest: "تغییر مکان میزبان و مهمان",
      takhfif: "تخفیف",
      listTakhfif:"لیست تخفیف ها",
      newTakhfif: "تخفیف جدید",
      takhfifFaal: "تخفیف",
      tarakoneshBank: "تراکنش های بانکی",
      tarikheSabtDarkhast: "تاریخ ثبت درخواست",
      tarikheTaghirVazeyat: "تاریخ تغییر وضعیت",
      taskTimeout: "اتمام مهلت تسک",
      tedadCardsActive: "فرم های فعال",
      tedadCardsLaghv: "فرم های لغو شده",
      tedadCardsMother: "فرم های مادر",
      tedadCardsTemp: "فرم های موقت",
      tedadCardsWinner: "فرم های برنده",
      tedadKolCard: "تعداد کل فرم ها",
      tedadNafar1: "تعداد نفرات اول",
      tedadNafar2: "تعداد نفرات دوم",
      tedadSahm1: "تعداد سهم اول",
      tedadSahm2: "تعداد سهم دوم",
      listTelegramUsers: "لیست کاربر های تلگرام",
      newTelegramUser: "افزودن کاربر تلگرام",
      telegram: "تلگرام",
      telegramBotAPI: "API تلگرام",
      telegramAdmin: "تلگرام مدیران سایت",
      temp: "موقت",
      tempDirectory: "مسیر پوشه موقت",
      terminalCod: "شماره شناسائی ترمینال",
      termService: "قوانین و مقررات",
      test: "تست",
      testMode: "وضعیت تست",
      thankYouMessage: "طراحی و توسعه تیم پشتیبانی",
      thisMonth: "این ماه",
      thisWeek: "این هفته",
      thisYear: "امسال",
      title: "عنوان",
      toDate: "تا تاریخ",
      today: "امروز",
      totalUsers: "تعداد کل کاربران",
      toTo: "توتو چیست؟",
      tozih: "توضیح",
      typeUser: "نوع کاربر",
      unblockIPAfterMinutes: "رفع انسداد IP پس از گذشت زمان (دقیقه)",
      unread: "خوانده نشده",
      unreadMessages: "پیام خوانده نشده",
      useAdminSystemLanguage: "زبان پیشفرض بخش مدیریت",
      user: "کاربر",
      userDefaultLanguage: "زبان پیش فرض بخش کاربر",
      userMehvar: "کاربر محور",
      userName: "نام کاربری",
      userPermision: "مدیریت سطح دسترسی",
      users: "کاربران",
      userValuable: "کاربران با ارزش",
      useUserSystemLanguage: "استفاده از زبان سیستم کاربر",
      vahedPool: "تومان",
      vazeyat: "وضعیت",
      viewForm: "مشاهده",
      webApiAddress: "آدرس وب سرویس",
      websiteUrl: "آدرس وب سایت",
      widthrawSuccessfull: "برداشت با موفقیت انجام شد.",
      win: "برد",
      win1percent: "درصد جایزه نفر اول",
      win2percent: "درصد جایزه نفر دوم",
      winFullPercent: "درصد کل جایزه",
      winner: "برنده",
      winners: "لیست برندگان",
      yes: "بله",
      yesterday: "دیروز",
      yourMessage: "پیام شما",
      zarib: "ضریب",
      inactive: "فعال نشده",
      allStates: "تمام وضعیت ها",
      deactivated: "غیر فعال",
      inactiveUsers: "تعداد کاربران فعال نشده",
      noeUsers: "نوع کاربری",
      refrenceOrNamayandeh: "نام کاربری نماینده کل و یا کاربر و یا سرشاخه",
      minimumMablaghSarshakhe: "حد اقل مبلغ مجموع فرم های  سرشاخه",
      dargahPardakhtActive: "فعال بودن درگاه پرداخت",
      ejazehErsalPayam: "فعال بودن ارسال پیام",
      faalBoodanDargah: "فعال بودن درگاه",
      dargahTamamKarbaran: "فعال بودن درگاه برای تمام کاربران",
      dargahNamKol: "فعال بودن درگاه برای نماینده کل",
      dargahNamJoz: "فعال بودن درگاه برای نماینده جز",
      dargahUserNamayandeh: "فعال بودن درگاه برای کاربران نماینده محور",
      dargahUserMehvar: "فعال بودن درگاه برای کاربران کاربر محور",
      dargahSarshakhe: "فعال بودن درگاه برای سرشاخه",
      entekhabTasvir: "انتخاب تصویر",
      payamSharj: "پیام شارژ حساب",
      toolSerial: "طول سریال"
    };
    this.language = lang;
    environment.language = lang;
  }

  getId(query = 'id') {
    let id = this.route.snapshot.queryParams[query] || 0;
    return id;
  }
}



// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/shared/shared.service.ts